module.exports = __webpack_public_path__ + "static/img/20003 (1).bbb1271.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20003 (1).webp
// module id = xq/Y
// module chunks = 14